import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsDoneWorksCosts(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COSTS,
		options
	)
}

function _getReportsDoneWorksCost(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST,
		options
	)
}

function _getReportsDoneWorksCostPreview(options = {}) {

	return _apiRequestWrap(
		ModulesMap.REPORTS_DONE_WORKS_COSTS,
		ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST_PREVIEW,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COSTS]: _getReportsDoneWorksCosts,

	[ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST]: _getReportsDoneWorksCost,

  [ModulesConfigMap[ModulesMap.REPORTS_DONE_WORKS_COSTS].GET_REPORTS_DONE_WORKS_COST_PREVIEW]: _getReportsDoneWorksCostPreview,
}
